import axios from 'axios'
import router from '../router'
const v = require('../config');
import CryptoJS from 'crypto-js'

const generateAPIEndPoint = () => {
    if (process.env.NODE_ENV === 'production') {
        return 'https://api-main.newgameslot.com/api/v2/me/'
    }
    return 'http://api-main.pg-newa05.com/api/v2/me/' // http://localhost:5000/api/v1
}

export const API_ENDPOINT = generateAPIEndPoint()

const instance = axios.create({
    baseURL: API_ENDPOINT,
    timeout: 5000
})
instance.interceptors.request.use(async(config) => {
    config.headers['Content-Type'] = 'application/json';
    //config.data // request data
    let token = localStorage.getItem('AccessToken')
    return {
        ...config,
        headers: {
            ...config.headers,
            ...(token && { authorization: `Bearer ${token}` }),
        },
    }
})
instance.interceptors.response.use(
    (response) => {
        if (response.data.Encrypt == true) {
            return JSON.parse(CryptoJS.AES.decrypt(response.data.data, v.Crypto_Secret).toString(CryptoJS.enc.Utf8))
        }
        return response.data
    },
    async(err) => {
        if (err.response) {
            if (err.response.status === 401) {
                if (router.name != 'Login' && router.name != 'Signup' && router.name != 'Join' && router.name != 'Not Found') {
                    await router.push("/login").catch(() => {});
                }
            }
            if (err.response.data.Encrypt == true) {
                return JSON.parse(CryptoJS.AES.decrypt(err.response.data.data, v.Crypto_Secret).toString(CryptoJS.enc.Utf8))
            }
            return Promise.reject(err.response.data)
        }
        return Promise.reject({
            status: {
                code: 0,
                message: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้ในขณะนี้'
            }
        })
    }
)
export default instance